'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { PasswordPolicySection } from '@/features/identity-policy';
export const Route = createFileRoute('/_staff/idp/_layout/settings/password/')({
  component: IdpPasswordSettingsPage
});
function IdpPasswordSettingsPage() {
  return <PasswordPolicySection editTo="/idp/settings/password/edit" />;
}